import React from 'react';
import SVGIconView from 'lib/images/svg-icon-view';
import FileInputView from 'four-nets/ui/form/file-input-view';
import camera from 'four-nets/icons/svg/icon_photoblogs.svg';
import { FormattedMessage } from 'react-intl';

class PhotoFileInputView extends React.PureComponent {
    setFileInput = ref => {
        this.fileInput = ref;
    };

    static defaultProps = {
        multiple: true,
    };

    render() {
        const { field, multiple, ...rest } = this.props;

        return (
            <FileInputView
                innerRef={this.setFileInput}
                accept={'image/*'}
                multiple={multiple}
                limit={15}
                disabled={field.form.submitting}
                icon={camera}
                field={field}
                {...rest}
            />
        );
    }
}

export default PhotoFileInputView;
